import sanitizeHtml from 'sanitize-html';
import isArray from 'lodash/isArray';
import trim from 'lodash/trim';
import { escapeRegExp } from '@zedoc/text';

/**
 * @param {string | undefined} type
 * @returns {string | undefined}
 */
const getClassNameByType = (type) => {
  switch (type) {
    case 'danger':
      return 'bg-danger';
    case 'success':
      return 'bg-success text-on-success';
    case 'warning':
      return 'bg-warning text-on-warning';
    case 'info':
      return 'bg-info text-on-info';
    case 'neutral':
      return 'bg-neutral text-on-neutral';
    default:
      return undefined;
  }
};

/**
 * @param {string | undefined} text
 * @param {string | string[] | undefined} highlight
 * @param {string | undefined} type
 * @param {string[] | undefined} exclude - do not mark matches inside these phrases
 * @returns {string}
 */
const renderSanitizedHtml = (text, highlight, type, exclude) => {
  if (!text) {
    return '';
  }
  if (!highlight) {
    return text;
  }
  if (!isArray(highlight)) {
    return renderSanitizedHtml(
      text,
      highlight.split(/\s+/).filter(Boolean),
      type,
      exclude,
    );
  }
  const regexes = highlight
    .filter(trim)
    .map((chunk) => new RegExp(`(\\b${escapeRegExp(chunk)}\\b)`, 'gi'));

  let highlightedText = text;
  const markClass = getClassNameByType(type);

  regexes.forEach((regex) => {
    highlightedText = highlightedText.replace(regex, (match) => {
      return `<mark class="${markClass}">${match}</mark>`;
    });
  });

  // Unmark exclude phrases: remove <mark> when content matches a negated phrase
  if (isArray(exclude) && exclude.length > 0) {
    exclude.filter(trim).forEach((phrase) => {
      const words = phrase.split(/\s+/).filter(Boolean);
      if (words.length === 0) return;
      const escapedWords = words.map((w) => escapeRegExp(w));
      const segment = escapedWords
        .map((w) => `(?:${w}|<mark class="[^"]*">${w}</mark>)`)
        .join('\\s+');
      const re = new RegExp(segment, 'gi');
      highlightedText = highlightedText.replace(re, (match) =>
        match.replace(/<mark[^>]*>|<\/mark>/g, ''),
      );
    });
  }

  return sanitizeHtml(highlightedText, {
    allowedTags: ['mark'],
    allowedAttributes: { mark: ['class'] },
  });
};

export default renderSanitizedHtml;
